import React, { Component } from 'react';
import DashboardContentContainer from './content/DashboardContentContainer';
import { connect } from 'react-redux';
import { getAuthentication } from '../../../auth/login/redux/selectors';

class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadDataFrequencyInSec: 10
        };
    }

    render() {
        return (
            <div className="dashboard-main-container container">
                <DashboardContentContainer
                    loadDataFrequencyInSec={this.state.loadDataFrequencyInSec}
                />
            </div>
        );
    }
}

const mapStateToProps = state => {
    const authentication = getAuthentication(state);

    return { authentication };
};

export default connect(mapStateToProps)(Dashboard);
